import { Core } from "@faire/design-tokens";
import supportArticle from "@faire/web-api/routes/support/articles/articleId";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Button } from "@faire/web/slate/Button";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import * as React from "react";

import { TooltipOrToast } from "@faire/retailer/components/TooltipOrToast/TooltipOrToast";
import { EXCLUSIVITY_ARTICLE } from "@faire/retailer/features/Exclusivity/consts";
import { getSettingEnableRetailerExclusivityAgreements } from "@faire/retailer/settings/getSettingEnableRetailerExclusivityAgreement";

interface IProps {
  targetNode: React.ReactNode;
  hidden?: boolean;
  usePortal?: boolean;
  portalTooltipYOffset?: number;
  pointerOffset?: number;
}

export const FaireProtectionTooltip: React.FC<IProps> = (props) => {
  const { strictLocalize } = useStrictLocalization();
  const zipcodeProtectionMessage = strictLocalize({
    defaultMessage:
      "A retailer in your zip code currently has exclusivity with this brand.",
    description: {
      text: "Message displayed when trying to move an item to bag from a brand that is zip code protected.",
    },
  });
  const exclusivityProtectionMessage = strictLocalize({
    defaultMessage:
      "A retailer in your area currently has exclusivity with this brand.",
    description: {
      text: "Message displayed when trying to add an item to bag from a brand that already have exclusivity with another retailer.",
      img: "https://cdn.faire.com/fastly/2441b3225e04e45b6e504acfd70792d4a5bc810a5d26c9b18f0252f0ec049068.png",
    },
  });
  const body = getSettingEnableRetailerExclusivityAgreements()
    ? exclusivityProtectionMessage
    : zipcodeProtectionMessage;

  return (
    <TooltipOrToast
      hidden={props.hidden}
      pointerOffset={props.pointerOffset}
      position="top"
      contents={[{ body }]}
      targetNode={props.targetNode}
      primary
      action={<FaireProtectionAction />}
      usePortal={props.usePortal}
      data-test-id="faire-protection-tooltip"
      portalTooltipYOffset={props.portalTooltipYOffset}
    />
  );
};

const FaireProtectionAction = () => {
  const linkTo = getSettingEnableRetailerExclusivityAgreements()
    ? EXCLUSIVITY_ARTICLE
    : supportArticle("360016111511");
  return (
    <Button
      variant="tertiary"
      tertiaryColor={Core.text.inverse}
      linkTo={linkTo}
      target="_blank"
    >
      <StrictLocalMsg
        defaultMessage="Learn more"
        description={{
          text: "Link to support article",
        }}
      />
    </Button>
  );
};
